import { render, staticRenderFns } from "./TopMenuItem.vue?vue&type=template&id=69d7c67e&"
import script from "./TopMenuItem.vue?vue&type=script&lang=js&"
export * from "./TopMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/surex/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69d7c67e')) {
      api.createRecord('69d7c67e', component.options)
    } else {
      api.reload('69d7c67e', component.options)
    }
    module.hot.accept("./TopMenuItem.vue?vue&type=template&id=69d7c67e&", function () {
      api.rerender('69d7c67e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/common/TopMenuItem.vue"
export default component.exports